import type { ActivityItem, ThemeImage } from '../api/client'
import type { GameItem, Language } from '../i18n'

export function formatGameTime(startTime: number | null, endTime: number | null): string {
  const ms   = startTime && endTime ? endTime - startTime : 0
  const secs = Math.floor(ms / 1000)
  return `${Math.floor(secs / 60)}:${String(secs % 60).padStart(2, '0')}`
}

export function shuffle<T>(arr: T[]): T[] {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

export function toGameItems(apiItems: ActivityItem[], language: Language): GameItem[] {
  return apiItems.map((item) => ({
    id:         item.id,
    emoji:      item.emoji,
    word:       item[language].word,
    definition: item[language].definition,
  }))
}

export function toGameItemsFromTheme(images: ThemeImage[], language: Language): GameItem[] {
  return images.map((img) => ({
    id:          img.id,
    emoji:       '',
    imageUrl:    img.url,
    word:        language === 'es' ? img.wordEs : img.wordEn,
    definition:  language === 'es' ? (img.definitionEs ?? '') : (img.definitionEn ?? ''),
    value:       img.value ?? undefined,
  }))
}
